<template>
  <div class="square__container">
    <div class="square__content-container">
      <SquareCompare
        v-for="(item, idx) in data"
        :key="`square-${idx}`"
        :data="item"
        :max="max"
        :scenarioLabels="scenarios"
      />
    </div>
    <div>
      <slot name="legend" />
    </div>
  </div>
</template>

<script>
import SquareCompare from "./SquareCompare.vue";
export default {
  components: {
    SquareCompare,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    scenarios: {
      type: Array,
    },
  },
};
</script>

<style scoped>
.square__container {
  width: 80%;
  display: flex;
  flex-flow: column;
  padding-top: 60px;
}
.square__content-container {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
</style>
